import { io } from 'socket.io-client';
import { getAuthToken } from './auth';

let socket = null;

export const initSocket = () => {
  if (socket?.connected) {
    return socket;
  }

  const token = getAuthToken();
  if (!token) {
    console.warn('[Socket] No auth token, cannot connect');
    return null;
  }

  const API_URL = import.meta.env.VITE_API_URL || (typeof window !== 'undefined' ? `${window.location.origin}/api` : 'http://localhost:5000/api');
  const socketUrl = API_URL.replace('/api', '');

  socket = io(socketUrl, {
    auth: {
      token: token
    },
    transports: ['websocket', 'polling'],
    reconnection: true,
    reconnectionDelay: 1000,
    reconnectionAttempts: 5
  });

  socket.on('connect', () => {
    if (import.meta.env.DEV) {
      console.log('[Socket] Connected:', socket.id);
    }
  });

  socket.on('disconnect', (reason) => {
    if (import.meta.env.DEV) {
      console.log('[Socket] Disconnected:', reason);
    }
  });

  socket.on('connect_error', (error) => {
    if (import.meta.env.DEV) {
      console.warn('[Socket] Connection error:', error?.message || error);
    }
  });

  return socket;
};

export const disconnectSocket = () => {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
};

export const getSocket = () => {
  if (!socket || !socket.connected) {
    return initSocket();
  }
  return socket;
};

